import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-toastr',
  templateUrl: './toastr.component.html',
  styleUrls: ['./toastr.component.scss']
})
export class ToastrComponent implements OnInit {

  constructor(private toastr: ToastrService) { }

  ngOnInit(): void {
  }
  showSuccess(message, title = "İşleminiz başarıyla gerçekleştirildi") {
    this.toastr.success(message, title);
  }
  showError(message, title = "İşlem gerçekleştirilemedi"){
    this.toastr.error(message, title);
  }
}
